import { Box, Chip, Spacing, SpeedDial, Stack, styled } from 'ui';

export const StyledHeader = styled(Stack)`
  position: fixed;
  padding: ${({ theme }) => theme.spacing(Spacing.Medium)};
  padding-left: 86px;
  height: 88px;
  background: ${({ theme }) => theme.palette.paper[200]};
  box-shadow: ${({ theme }) => theme.boxShadows.card};
  z-index: 1201;
  color: ${({ theme }) => theme.palette.text.primary};
  width: 100%;
  margin-top: 56px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const StyledPendingSetupChip = styled(Chip)`
  border-radius: ${({ theme }) => theme.borderRadii.outer};
  background-color: ${({ theme }) => theme.palette.orange[200]};
  color: ${({ theme }) => theme.palette.orange[600]};
  font-weight: 500;
`;

export const StyledFieldsContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing(Spacing.Small)};
`;

export const StyledOrgFieldWrapper = styled(Box)`
  flex: 1;
  min-width: 160px;
  max-width: 256px;
  margin-right: ${({ theme }) => theme.spacing(Spacing.Small)};
`;

export const StyledCaseFieldWrapper = styled(Box)`
  flex: 1;
  min-width: 160px;
  max-width: 400px;
`;

export const SpeedDialWrapper = styled(SpeedDial)`
  position: fixed;
  bottom: 5%;
  right: 5%;
  z-index: 9999;
`;
